@if (!isLoading) {
  <div class="add-button" (click)="onButtonClick()">
    <i class={{iconClass}}></i>
    @if (title) {
      <a>{{title}}</a>
    }
  </div>
}